import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAutoSelectWeek } from "./utils";

interface State {
  currentWeekIndex: number;
  weekIndex: number;
}

const initialState: State = {
  currentWeekIndex: 0,
  weekIndex: 0,
};

interface AutoSelectWeek {
  numWeeks: number;
  startDate: string;
}

interface SetWeekIndex {
  weekIndex: number;
}

const programSlice = createSlice({
  name: "program",
  initialState,
  reducers: {
    autoSelectWeek(state, action: PayloadAction<AutoSelectWeek>) {
      const { numWeeks, startDate } = action.payload;

      const weekIndex = getAutoSelectWeek(startDate);

      const value = Math.min(weekIndex, numWeeks - 1);

      state.weekIndex = value;
      state.currentWeekIndex = value;
    },
    setWeekIndex(state, action: PayloadAction<SetWeekIndex>) {
      state.weekIndex = action.payload.weekIndex;
    },
  },
});

export const { autoSelectWeek, setWeekIndex } = programSlice.actions;

export const programSliceReducer = programSlice.reducer;
